exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-progress{display:none}.vue-dropzone .dz-preview .dz-remove{top:0;right:0;opacity:1;background:rgba(78,115,138,.95);bottom:auto;padding:5px 7.5px;border:0}", ""]);

// exports
